import { Country } from "../models";

export const getCountryCode = (countries: Country[], selectedCountryId: number): string => {
	if (countries && countries.length && selectedCountryId) {
		return countries.find(c => c.id === selectedCountryId)?.code as string;
	}
	return "US";
};
